import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Nav from "@/components/Nav";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      if (data.token) localStorage.setItem("vr_admin_token", data.token);
      toast.success("Selamat datang, Admin");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login gagal");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen">
      <Nav />
      <div className="max-w-md mx-auto px-4 md:px-8 py-20">
        <div className="text-[10px] tracking-[0.3em] text-[#FF3B30] font-display">CONTROL ROOM</div>
        <h1 className="font-display text-5xl mt-3">ADMIN LOGIN</h1>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <div>
            <div className="text-[10px] tracking-widest text-white/60 uppercase font-display mb-2">Email</div>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="tactical-input" data-testid="admin-email" />
          </div>
          <div>
            <div className="text-[10px] tracking-widest text-white/60 uppercase font-display mb-2">Password</div>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="tactical-input" data-testid="admin-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-blaze w-full" data-testid="admin-submit">{loading ? "..." : "SIGN IN"}</button>
        </form>
      </div>
    </div>
  );
}
